import React from "react";
import store from "store";
import $ from "jquery";
import {
  AjaxSetup,
  API_LOGIN,
  API_SHORT_PROFILE,
  API_PROGRAM,
  API_VERIFY_EMAIL,
  QueryParam,
  BASE_URL,
} from "../Util";
import { notify } from "react-notify-toast";
import Page from "../Page";
import "../../styles/captcha.css";
import "../../styles/login.css";
import { trans } from "../Lang";
import { Button, Modal } from "react-materialize";
import LoginSmile from "./components/LoginSmile";
import LoginEmail from "./components/LoginEmail";
import Tab from "./components/Tab";

class Login extends Page {
  static GOOGLE = "google";
  static EMAIL = "email";
  static CLIENT_WEB = "web";
  static CLIENT_TOKEN = "ef82ef838e94ff1f3bfe43cadb7eb569b954d196";

  constructor(props) {
    super(props);
    let params = QueryParam();

    this.state = {
      username: "",
      password: "",
      token: params.token,
      api_token: params.api_token,
      is_password_hidden: true,
      is_valid_username: true,
      set_failed_counter: 3,
      set_countdown: 60,
      activation_token: params.token,
      email: params.email,
      // type:
      //   params.smile_account &&
      //   ["1", "true"].includes(params.smile_account.toString())
      //     ? "smile"
      //     : "email",
      type: "email",
      optionPrograms: [],
    };

    this.regexEmail = RegExp(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/);
  }

  componentDidMount() {
    $(".modal-overlay").trigger("click");
    let { api_token } = this.state;

    api_token = api_token || store.get("auth_token");

    if (QueryParam("redirect")) {
      notify.show("Anda harus login terlebih dahulu", "warning", 3000);
    }

    this.getPrograms();

    if (api_token) {
      store.set("auth_token", "Bearer " + api_token);
      this.grabProfile(api_token);
    }
    let { email, activation_token } = this.state;

    if (email && activation_token) {
      this.handleVerifyEmail(email, activation_token);
    }
  }

  handleVerifyEmail = (email, token) => {
    $.post(API_VERIFY_EMAIL, { email: email, token: token }).then((result) => {
      if (result.status === "failed") {
        notify.show(result.message, "warning", 3000);
      } else {
        notify.show(result.payload, "success", 3000);
      }
    });
  };

  handleSubmit = ({ username, password, programId }) => {
    const { type } = this.state;

    if (type == "smile") {
      this.setState({
        username_smile: username,
        password_smile: password,
        program_id: programId,
      });
      $("#trigger-modal-email").trigger("click");
    }
  };

  handleSubmitForm = async (credentials) => {
    let { username_smile, password_smile, program_id, type } = this.state;

    // if (username && password) {
    //   if (username.length < 1 || password.length < 6) {
    //     this.setState({
    //       is_valid_username: username.length >= 2,
    //       is_valid_password: password.length >= 6,
    //     });
    //   } else {
    this.handleLogin({
      username_smile,
      password_smile,
      program_id,
      login_type: type == "smile" ? "smile" : "email",
      client_token: Login.CLIENT_TOKEN,
      ...credentials,
    });
    //   }
    // } else {
    //   notify.show("Email dan password tidak boleh kosong", "warning");
    // }
  };

  handleLogin = (param) => {
    $.post(API_LOGIN, param)
      .then((data) => {
        if (data.payload) {
          store.set("auth_token", "Bearer " + data.payload.token);
          // window.location.reload();
          this.grabProfile(data.payload.token);
        } else {
          notify.show(
            "Terdapat kesalahan dalam melakukan login, silakan coba lagi",
            "warning"
          );
          this.setState({ loading: false });
        }
      })
      .fail((XMLHttpRequest) => {
        let response;

        try {
          response = JSON.parse(XMLHttpRequest.responseText);
        } catch (e) {}

        if (response && response.status) {
          notify.show("Username atau password salah", "warning");
          // notify.show(response.message, "warning");
        }
      });
  };

  grabProfile = () => {
    AjaxSetup(this.props);

    $.get(API_SHORT_PROFILE).then((data) => {
      if (("grabProfile", data.payload)) {
        let {
          name,
          email,
          avatar_url,
          account_type,
          username,
          is_businessman,
          phone,
          smile_id,
          smile_username,
          completed_profile,
          ...rest
        } = data.payload;

        let userdata = {
          nama: name,
          email: email,
          foto: avatar_url ? avatar_url : BASE_URL + "/img/avatar.png",
          account_type: account_type,
          saldo: rest.deposit_balance,
          saldoput: rest.put_balance,
          agenid: username,
          is_businessman,
          phone,
          smile_id: smile_id,
          smile_username: smile_username,
          program: rest.program,
          program_id: rest.program_id,
          entity_type: rest.entity_type,
          entity_type_id: rest.entity_type_id,
          uuid: rest.uuid,
          completed_profile,
        };

        store.set("userdata", userdata);

        this.redirectAfterLogin();
      }
    });
  };

  getPrograms = () => {
    $.get(API_PROGRAM).then((data) => {
      if (data.payload) {
        let options = [...data.payload];
        options = options.filter((opt) => opt.has_url);
        options =
          options.map((obj) => ({
            label: obj.name,
            value: obj.id,
          })) || [];

        this.setState({ optionPrograms: options });
      }
    });
  };

  redirectAfterLogin = () => {
    let redirect = QueryParam("redirect");

    if (!redirect || redirect === "/login") {
      redirect = "/";
    }

    this.props.history.push(redirect);
  };

  handleUsernameChange = (e) => {
    this.setState({ username: e.target.value });
  };

  handlePasswordChange = (e) => {
    this.setState({ password: e.target.value });
  };

  handleToggleShowPassword = () => {
    this.setState({ is_password_hidden: !this.state.is_password_hidden });
  };

  render() {
    const { type, username_smile } = this.state;
    return (
      <div className="bg-grey">
        <div className="pt-m pb-l">
          <form className="form-auth bg-white">
            <div className="px-l pt-m inline-block full-width">
              <div className="center mb-s">
                <img
                  className="form-auth-header-logo"
                  src={BASE_URL + "/img/white-label/logo/SMILE_Logo_HD.png"}
                  style={{ maxWidth: "100%" }}
                />
              </div>
              {/* <Tab active={type} onChange={(type) => this.setState({ type })} /> */}
              {type == "smile" ? (
                <LoginSmile
                  optionPrograms={this.state.optionPrograms}
                  onSubmit={this.handleSubmit}
                />
              ) : (
                <LoginEmail onSubmit={this.handleSubmitForm} />
              )}
            </div>
            <div className="text-center pb-m">&nbsp;</div>
          </form>
        </div>
        <Modal
          header="Masuk dengan akun smile elearning"
          trigger={
            <Button
              waves="light"
              id="trigger-modal-email"
              style={{ display: "none" }}
            >
              Open
            </Button>
          }
        >
          <LoginEmail
            username_smile={username_smile}
            onSubmit={this.handleSubmitForm}
          />
        </Modal>
        ;
      </div>
    );
  }
}

export default Login;



// WEBPACK FOOTER //
// ./src/components/Auth/Login.js